<template>
  <div class="wa-mockup">
    <!-- Barra Superior WhatsApp -->
    <div class="wa-header">
      <div class="d-flex align-items-center">
        <i class="mdi mdi-arrow-left text-white me-2"></i>
        <div class="wa-avatar me-2">
          <i class="mdi mdi-whatsapp text-white"></i>
        </div>
        <div class="wa-contact-info">
          <div class="wa-name">
            {{ nombreEmpresa }}
            <i class="mdi mdi-check-decagram text-white font-size-11 ms-1" title="Cuenta comercial verificada"></i>
          </div>
          <div class="wa-status">Cuenta de empresa oficial</div>
        </div>
      </div>
      <div class="wa-header-icons">
        <i class="mdi mdi-video text-white me-2"></i>
        <i class="mdi mdi-phone text-white me-2"></i>
        <i class="mdi mdi-dots-vertical text-white"></i>
      </div>
    </div>

    <!-- Pantalla de Mensajes con Fondo WhatsApp -->
    <div class="wa-body">
      <!-- Aviso si el servicio está apagado -->
      <div class="text-center my-1" v-if="!activo">
        <span class="wa-disabled-banner">
          <i class="mdi mdi-power-off font-size-10 me-1"></i>
          WhatsApp Business desactivado
        </span>
      </div>

      <!-- Badge de Cifrado / Aviso Meta -->
      <div class="text-center my-2">
        <span class="wa-crypto-badge">
          <i class="mdi mdi-lock font-size-10 me-1"></i>
          Los mensajes están cifrados de extremo a extremo.
        </span>
      </div>

      <!-- Burbuja de Chat WhatsApp -->
      <div class="wa-bubble shadow-sm" v-if="plantilla">
        <!-- Encabezado de Imagen (Media Header) -->
        <div class="wa-bubble-media" v-if="plantilla.tipo_encabezado === 'IMAGE'">
          <img
            v-if="plantilla.url_imagen_encabezado"
            :src="plantilla.url_imagen_encabezado"
            class="wa-bubble-img"
            alt="Comprobante de pago"
          />
          <div class="wa-bubble-img-placeholder" v-else>
            <i class="mdi mdi-image-outline font-size-36 text-muted mb-1"></i>
            <span class="font-size-11 text-muted fw-semibold">Comprobante / Imagen dinámica</span>
          </div>
        </div>

        <!-- Encabezado de Texto -->
        <div class="wa-bubble-header" v-else-if="plantilla.tipo_encabezado === 'TEXT' && plantilla.encabezado">
          {{ renderVistaPrevia(plantilla.encabezado) }}
        </div>

        <!-- Cuerpo del Mensaje con Variables Reemplazadas -->
        <div class="wa-bubble-body">
          {{ renderVistaPrevia(plantilla.cuerpo) }}
        </div>

        <!-- Pie de Página -->
        <div class="wa-bubble-footer" v-if="plantilla.pie">
          {{ renderVistaPrevia(plantilla.pie) }}
        </div>

        <!-- Metadata de la Burbuja (Hora y doble check) -->
        <div class="wa-bubble-meta">
          <span class="wa-time">{{ horaActual }}</span>
          <i class="mdi mdi-check-all text-primary font-size-13 ms-1"></i>
        </div>
      </div>
    </div>

    <!-- Barra Inferior de Entrada (Falsa) -->
    <div class="wa-input-bar">
      <div class="wa-input-pill">
        <i class="mdi mdi-emoticon-happy-outline text-muted me-2"></i>
        <span class="text-muted font-size-12">Mensaje</span>
      </div>
      <div class="wa-mic-btn">
        <i class="mdi mdi-microphone text-white"></i>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'CmpPreviewMockupWhatsapp',
  props: {
    plantilla: {
      type: Object,
      default: () => ({})
    },
    activo: {
      type: Boolean,
      default: true
    },
    nombreEmpresa: {
      type: String,
      default: 'ArgusBlack ISP'
    }
  },
  computed: {
    horaActual() {
      return moment().format('HH:mm')
    }
  },
  methods: {
    renderVistaPrevia(texto) {
      if (!texto) return ''
      let empresa = this.nombreEmpresa || 'ArgusBlack ISP'
      return texto
        // Datos de la empresa
        .replace(/\{\{(nombre_empresa|empresa)\}\}/gi, empresa)
        // Datos del cliente
        .replace(/\{\{(nombre_completo|cliente)\}\}/gi, 'Carlos Mendoza López')
        .replace(/\{\{nombre\}\}/gi, 'Carlos')
        .replace(/\{\{apellido_paterno\}\}/gi, 'Mendoza')
        .replace(/\{\{apellido_materno\}\}/gi, 'López')
        .replace(/\{\{rfc\}\}/gi, 'MELC850101XXX')
        .replace(/\{\{sexo\}\}/gi, 'Masculino')
        .replace(/\{\{tipo_cliente\}\}/gi, 'Residencial')
        .replace(/\{\{estado\}\}/gi, 'Activo')
        .replace(/\{\{calle\}\}/gi, 'Av. Insurgentes Sur')
        .replace(/\{\{numero_exterior\}\}/gi, '123')
        .replace(/\{\{numero_interior\}\}/gi, '4B')
        .replace(/\{\{colonia\}\}/gi, 'Del Valle')
        .replace(/\{\{delegacion\}\}/gi, 'Benito Juárez')
        .replace(/\{\{codigo_postal\}\}/gi, '03100')
        .replace(/\{\{estado_residencia\}\}/gi, 'CDMX')
        .replace(/\{\{pais\}\}/gi, 'México')
        .replace(/\{\{correo_electronico\}\}/gi, 'cliente@ejemplo.com')
        .replace(/\{\{telefono\}\}/gi, '+52 55 1234 5678')
        .replace(/\{\{numero_ticket\}\}/gi, 'TKT-9482')
        .replace(/\{\{fecha_registro\}\}/gi, moment().format('DD/MM/YYYY'))
        .replace(/\{\{hora_registro\}\}/gi, moment().format('HH:mm'))
        .replace(/\{\{(importe|monto)\}\}/gi, '$450.00 MXN')
        .replace(/\{\{pago\}\}/gi, '$500.00 MXN')
        .replace(/\{\{cambio\}\}/gi, '$50.00 MXN')
        .replace(/\{\{metodo_pago\}\}/gi, 'Efectivo')
        .replace(/\{\{cajero\}\}/gi, 'Caja Principal')
        .replace(/\{\{saldo_pendiente\}\}/gi, '$0.00 MXN')
        .replace(/\{\{saldo_total\}\}/gi, '$0.00 MXN')
        .replace(/\{\{fecha_limite\}\}/gi, moment().add(5, 'days').format('DD/MM/YYYY'))
        .replace(/\{\{facturas\}\}/gi, 'FAC-08492')
        .replace(/\{\{enlace_pago\}\}/gi, 'https://pagos.tu-isp.com/p/8492')
    }
  }
}
</script>

<style scoped>
.wa-mockup {
  width: 100%;
  max-width: 360px;
  background-color: #efeae2;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  border: 8px solid #1f2c34;
  display: flex;
  flex-direction: column;
}

.wa-header {
  background-color: #075e54;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wa-avatar {
  width: 34px;
  height: 34px;
  background-color: #25d366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.wa-contact-info {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.wa-name {
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  max-width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wa-status {
  color: #e0f2f1;
  font-size: 10px;
}

.wa-body {
  padding: 14px 10px;
  min-height: 380px;
  background-image: radial-gradient(#d4cbbf 1px, transparent 1px);
  background-size: 16px 16px;
  display: flex;
  flex-direction: column;
}

.wa-crypto-badge {
  background-color: #ffeecd;
  color: #54656f;
  font-size: 10px;
  padding: 4px 10px;
  border-radius: 6px;
  display: inline-block;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
}

.wa-disabled-banner {
  background-color: #f8d7da;
  color: #842029;
  font-size: 10px;
  padding: 4px 10px;
  border-radius: 6px;
  display: inline-block;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
}

.wa-bubble {
  background-color: #ffffff;
  border-radius: 8px 8px 8px 0px;
  padding: 10px 12px 6px 12px;
  max-width: 90%;
  position: relative;
  margin-top: 8px;
  border: 1px solid rgba(0,0,0,0.05);
}

.wa-bubble-media {
  margin: -10px -12px 8px -12px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
  background-color: #e9edef;
}

.wa-bubble-img {
  width: 100%;
  max-height: 160px;
  object-fit: cover;
  display: block;
}

.wa-bubble-img-placeholder {
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
  border-bottom: 1px solid #e9edef;
  padding: 10px;
}

.wa-bubble-header {
  font-weight: bold;
  font-size: 13px;
  color: #111b21;
  margin-bottom: 6px;
  border-bottom: 1px solid #f0f2f5;
  padding-bottom: 4px;
}

.wa-bubble-body {
  font-size: 12.5px;
  color: #111b21;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}

.wa-bubble-footer {
  font-size: 11px;
  color: #667781;
  margin-top: 6px;
  border-top: 1px dashed #e9edef;
  padding-top: 4px;
}

.wa-bubble-meta {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 10px;
  color: #667781;
  margin-top: 4px;
}

.wa-input-bar {
  background-color: #f0f2f5;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.wa-input-pill {
  flex: 1;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 6px 12px;
  display: flex;
  align-items: center;
}

.wa-mic-btn {
  width: 32px;
  height: 32px;
  background-color: #00a884;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

